/**
 * Super-Admin auth store (Zustand) — cookie-based auth.
 */
import { create } from 'zustand';
import saApi from '../services/superAdminApi';

interface SAAuthState {
  name: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  checkAuth: () => Promise<void>;
}

export const useSAStore = create<SAAuthState>((set) => ({
  name: localStorage.getItem('sa_name'),
  isAuthenticated: false,
  isLoading: false,

  login: async (email: string, password: string) => {
    set({ isLoading: true });
    try {
      const { data } = await saApi.post('/superadmin/login', { email, password });
      // Токены установлены сервером в httpOnly cookies
      localStorage.setItem('sa_name', data.name || 'Super Admin');
      set({ isAuthenticated: true, name: data.name, isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      throw error;
    }
  },

  logout: async () => {
    try {
      await saApi.post('/auth/logout');
    } catch {
      // Даже при ошибке — сбрасываем состояние
    }
    localStorage.removeItem('sa_name');
    set({ name: null, isAuthenticated: false });
  },

  checkAuth: async () => {
    try {
      // Проверяем авторизацию через API
      const { data } = await saApi.get('/superadmin/me');
      localStorage.setItem('sa_name', data.name || 'Super Admin');
      set({ isAuthenticated: true, name: data.name });
    } catch {
      set({ isAuthenticated: false, name: null });
    }
  },
}));
